var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("div", { ref: "lgContainer", staticStyle: { display: "none" } }),
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: "",
            "hide-overlay": "",
            persistent: "",
            "no-click-animation": "",
            transition: "dialog-bottom-transition",
          },
          model: {
            value: _vm.new_weld_dialog,
            callback: function ($$v) {
              _vm.new_weld_dialog = $$v
            },
            expression: "new_weld_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-container",
                { staticClass: "container--app pa-0" },
                [
                  _c(
                    "v-form",
                    { ref: "weldForm", staticClass: "d-flex flex-grow-1" },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "d-flex flex-row align-center justify-space-between",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.advancedWeldLog.updateWeldLog"
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: { click: _vm.closeDialog },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: _vm.$vuetify.theme.dark
                                          ? "white"
                                          : "black",
                                      },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-row flex-wrap pa-0",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "6", lg: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      label: _vm.$t(
                                        "message.advancedWeldLog.projectName"
                                      ),
                                      value: _vm.drawing.project.project_name,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", lg: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      label: _vm.$t(
                                        "message.advancedWeldLog.poRanked"
                                      ),
                                      value: _vm.drawing.project.po_ranked,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", lg: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      label: _vm.$t(
                                        "message.advancedWeldLog.aoRanked"
                                      ),
                                      value: _vm.drawing.project.ao_ranked,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", lg: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      label: _vm.$t(
                                        "message.projectFeature.NDTSpecifications"
                                      ),
                                      value: _vm.computedNdtSpecification,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 py-2", attrs: { cols: "12" } },
                            [_c("v-divider")],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-row flex-wrap pa-0",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "6", lg: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      disabled: "",
                                      dense: "",
                                      "hide-details": "",
                                      type: "text",
                                      small: "",
                                      label: _vm.$t(
                                        "message.advancedWeldLog.weldNo"
                                      ),
                                      outlined: "",
                                    },
                                    model: {
                                      value: _vm.weld_row.weld_nr,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.weld_row, "weld_nr", $$v)
                                      },
                                      expression: "weld_row.weld_nr",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", lg: "4" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      disabled: "",
                                      clearable: "",
                                      items: _vm.drawing.project.wpqr,
                                      "item-text": "document_type",
                                      "return-object": "",
                                      dense: "",
                                      "hide-details": "",
                                      outlined: "",
                                      label: _vm.$t(
                                        "message.advancedWeldLog.wps"
                                      ),
                                      value: _vm.weld_row.wps_nr,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", lg: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      disabled: "",
                                      "hide-details": "",
                                      type: "text",
                                      dense: "",
                                      label: _vm.$t(
                                        "message.advancedWeldLog.weldingConsumables"
                                      ),
                                      outlined: "",
                                    },
                                    model: {
                                      value: _vm.weld_row.filler_materials,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.weld_row,
                                          "filler_materials",
                                          $$v
                                        )
                                      },
                                      expression: "weld_row.filler_materials",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", lg: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "hide-details": "",
                                      type: "text",
                                      dense: "",
                                      label: _vm.$t(
                                        "message.advancedWeldLog.batchNumber"
                                      ),
                                      outlined: "",
                                    },
                                    model: {
                                      value: _vm.weld_row.charge_nr,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.weld_row, "charge_nr", $$v)
                                      },
                                      expression: "weld_row.charge_nr",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", lg: "4" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      multiple: "",
                                      items: _vm.expertise,
                                      "item-text": "text",
                                      "item-value": "expertise_id",
                                      dense: "",
                                      "hide-details": "auto",
                                      outlined: "",
                                      label: _vm.$t(
                                        "message.advancedWeldLog.welderCertificates"
                                      ),
                                      rules: [
                                        function (val) {
                                          return (
                                            !_vm.weld_row.weld_end ||
                                            (val && val.length > 0) ||
                                            _vm.$t(
                                              "message.advancedWeldLog.certificateRequiredWhenWeldEnd"
                                            )
                                          )
                                        },
                                      ],
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var item = ref.item
                                          var index = ref.index
                                          return [
                                            index === 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "v-select__selection v-select__selection--comma",
                                                  },
                                                  [_vm._v(_vm._s(item.text))]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                      {
                                        key: "prepend-item",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: "Search",
                                                    "append-icon":
                                                      "mdi-magnify",
                                                    dense: "",
                                                    outlined: "",
                                                    "hide-details": "",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value: _vm.expertiseSearch,
                                                    callback: function ($$v) {
                                                      _vm.expertiseSearch = $$v
                                                    },
                                                    expression:
                                                      "expertiseSearch",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.weld_row.weldlog_expertise_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.weld_row,
                                          "weldlog_expertise_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "weld_row.weldlog_expertise_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", lg: "4" } },
                                [
                                  _c("date-time-picker", {
                                    attrs: {
                                      label: _vm.$t(
                                        "message.advancedWeldLog.weldEnd"
                                      ),
                                      clearable: "",
                                      "prepend-inner-icon": "mdi-calendar",
                                      "menu-props": {
                                        contentClass: "weld-end-calendar",
                                      },
                                    },
                                    model: {
                                      value: _vm.weld_row.weld_end,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.weld_row, "weld_end", $$v)
                                      },
                                      expression: "weld_row.weld_end",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex flex-row flex-wrap pa-0",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "3", md: "4" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.$t(
                                            "message.advancedWeldLog.ndt"
                                          ),
                                          disabled: "",
                                          value: "VT",
                                          outlined: "",
                                          "hide-details": "",
                                          dense: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "3", md: "4" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          disabled: "",
                                          "aria-valuemin": "1",
                                          "aria-valuemax": "100",
                                          outlined: "",
                                          placeholder: "%",
                                          type: "number",
                                          "hide-details": "",
                                          dense: "",
                                          label: "%",
                                        },
                                        model: {
                                          value: _vm.weld_row.vt_scope,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.weld_row,
                                              "vt_scope",
                                              $$v
                                            )
                                          },
                                          expression: "weld_row.vt_scope",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6", md: "4" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          value: _vm.weld_row.vt_sign,
                                          "hide-details": "",
                                          dense: "",
                                          label: _vm.$t(
                                            "message.advancedWeldLog.sign"
                                          ),
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "append",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "button",
                                                  {
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: _vm.signNdtType,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: !_vm.weld_row
                                                            .vt_sign
                                                            ? "red"
                                                            : "green",
                                                        },
                                                      },
                                                      [_vm._v(" mdi-check ")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", lg: "6" } },
                                [
                                  _c("v-textarea", {
                                    attrs: {
                                      "hide-details": "",
                                      label: _vm.$t(
                                        "message.advancedWeldLog.comments"
                                      ),
                                      outlined: "",
                                      rows: "3",
                                    },
                                    model: {
                                      value: _vm.weld_row.comments,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.weld_row, "comments", $$v)
                                      },
                                      expression: "weld_row.comments",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-row flex-wrap pa-0",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex justify-center",
                                  attrs: { cols: "6" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "text-none d-flex flex-grow-1 blue lighten-4 weldlog-link-btn",
                                      attrs: {
                                        disabled: !_vm.computedWPS.length,
                                        plain: "",
                                        rounded: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openPreviewModal("WPS")
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("mdi-link")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.advancedWeldLog.wps"
                                            )
                                          )
                                      ),
                                      _vm.weld_row.wps_nr
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "ml-1 text-truncate",
                                            },
                                            [
                                              _vm._v(
                                                "- (" +
                                                  _vm._s(_vm.weld_row.wps_nr) +
                                                  ")"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex justify-center",
                                  attrs: { cols: "6" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openPreviewModal("drawings")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "text-none d-flex flex-grow-1 blue lighten-4 weldlog-link-btn",
                                      attrs: {
                                        disabled: !_vm.drawing.documents.length,
                                        plain: "",
                                        rounded: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("mdi-link")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.advancedWeldLog.drawing"
                                            )
                                          )
                                      ),
                                      _vm.drawing.drawning_nr
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "ml-1 text-truncate",
                                            },
                                            [
                                              _vm._v(
                                                "- (" +
                                                  _vm._s(
                                                    _vm.drawing.drawning_nr
                                                  ) +
                                                  ")"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex flex-column flex-wrap",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("input", {
                                ref: "fileInput",
                                staticClass: "d-none",
                                attrs: { type: "file" },
                                on: { change: _vm.handleFileUpload },
                              }),
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "text-none d-flex flex-grow-1 blue lighten-4 weldlog-link-btn",
                                  attrs: {
                                    type: "button",
                                    plain: "",
                                    rounded: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$refs.fileInput.click()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", small: "" } },
                                    [_vm._v("mdi-file-upload-outline")]
                                  ),
                                  _vm._v(" Upload Document "),
                                ],
                                1
                              ),
                              _c(
                                "v-list",
                                { staticClass: "mt-3", attrs: { dense: "" } },
                                _vm._l(
                                  _vm.weld_row.files,
                                  function (file, index) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: index,
                                        staticClass:
                                          "d-flex justify-space-between align-center",
                                      },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              { staticClass: "text-truncate" },
                                              [_vm._v(_vm._s(file.name))]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { small: "", icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeFile(index)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { color: "red" } },
                                              [_vm._v("mdi-delete")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "d-flex flex-row justify-space-between",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "text-none",
                                  attrs: { type: "button", color: "error" },
                                  on: { click: _vm.closeDialog },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.advancedWeldLog.cancel")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "text-none",
                                  attrs: {
                                    loading: _vm.create_loading,
                                    disabled: _vm.create_loading,
                                    color: "primary",
                                  },
                                  on: { click: _vm.submitForm },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.advancedWeldLog.submit")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.selectedDrawing.id && _vm.weldMappingAvailable
        ? _c(
            "div",
            { staticClass: "d-flex justify-end mb-2" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "text-none",
                  attrs: { small: "", outlined: "", color: "primary" },
                  on: { click: _vm.openWeldMapping },
                },
                [
                  _c("v-icon", { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-plus"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("message.advancedWeldLog.addFieldWeld")) +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-menu",
        {
          attrs: {
            bottom: "",
            "close-on-content-click": false,
            "nudge-bottom": 50,
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-text-field",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            outlined: "",
                            value: _vm.selectedDrawing.name,
                            label: _vm.$t(
                              "message.advancedWeldLog.selectDrawing"
                            ),
                            readonly: "",
                            "append-icon": "mdi-menu-down",
                            dense: "",
                          },
                          on: { "click:append": on.click },
                        },
                        "v-text-field",
                        attrs,
                        false
                      ),
                      on
                    )
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _c("v-card", [
            _c(
              "div",
              [
                _c("v-text-field", {
                  staticClass: "px-4 mt-2",
                  attrs: {
                    label: _vm.$t("message.advancedWeldLog.searchDrawings"),
                    "prepend-inner-icon": "mdi-magnify",
                    dense: "",
                    clearable: "",
                    "hide-details": "",
                    outlined: "",
                    rounded: "",
                  },
                  model: {
                    value: _vm.treeSearch,
                    callback: function ($$v) {
                      _vm.treeSearch = $$v
                    },
                    expression: "treeSearch",
                  },
                }),
                _c("v-treeview", {
                  staticClass: "treeview-projects",
                  attrs: {
                    search: _vm.treeSearch,
                    items: _vm.treeData,
                    active: _vm.active,
                    activatable: "",
                    "open-all": "",
                    "item-key": "id",
                    "item-text": "name",
                    "item-children": "children",
                    dense: "",
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.active = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "prepend",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-decoration-none text--black d-flex flex-row flex-grow-1 tree-label",
                              class: {
                                "text--disabled":
                                  !item.data || item.data.has_weldlog !== 1,
                              },
                              style: {
                                cursor:
                                  item.data && item.data.has_weldlog === 1
                                    ? "pointer"
                                    : "not-allowed",
                              },
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  item.data &&
                                    item.data.has_weldlog &&
                                    _vm.selectItem(item)
                                },
                              },
                            },
                            [
                              item.icon === "weld_icon"
                                ? _c("weld-icon", [_vm._v("mdi-wrench")])
                                : item.type === "folder"
                                ? _c("v-icon", { attrs: { size: "34" } }, [
                                    _vm._v("mdi-folder"),
                                  ])
                                : _c("v-icon", [_vm._v("mdi-file")]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "label",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-decoration-none text--black d-flex flex-row flex-grow-1 tree-label",
                              class: {
                                "text--disabled":
                                  !item.data || item.data.has_weldlog !== 1,
                              },
                              style: {
                                cursor:
                                  item.data && item.data.has_weldlog === 1
                                    ? "pointer"
                                    : "not-allowed",
                              },
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  item.data &&
                                    item.data.has_weldlog &&
                                    _vm.selectItem(item)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(item.name) + " ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass:
            "pa-0 d-flex flex-row align-content-center justify-space-between mb-3",
          attrs: { cols: "12" },
        },
        [
          _c("v-text-field", {
            staticClass: "mb-2",
            attrs: {
              label: _vm.$t("message.advancedWeldLog.searchWeldLogs"),
              "prepend-inner-icon": "mdi-magnify",
              dense: "",
              clearable: "",
              "hide-details": "",
              outlined: "",
              rounded: "",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          "no-data-text": !_vm.selectedDrawing.id
            ? _vm.$t("message.advancedWeldLog.selectDrawingToLoadWeldLogs")
            : _vm.$t("message.advancedWeldLog.noWeldLogResultsFound"),
          loading: _vm.loading,
          search: _vm.search,
          "disable-sort": "",
          headers: _vm.tableHeaders,
          items: _vm.weld_logs,
          "items-per-page": 20,
          "item-class": _vm.getWeldlogRecordBgByStatus,
        },
        on: { "click:row": _vm.editWeldLogEntry },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }